export const getFormatClientsIds = (context) => {
  const { clientIDs } = { ...context };
  const { ga: client_id, sessionId: session_id } = { ...clientIDs };
  const ga = {};
  if (client_id) {
    ga.client_id = client_id;
  }
  // se incluye session_id solo si existe client_id y tiene formato correcto
  if (session_id && client_id) {
    const gaRegex = /^\d+\.\d+$/;
    if (gaRegex.test(client_id)) {
      ga.session_id = session_id;
    }
  }
  const gaIds = JSON.stringify(ga);
  const gaIdsEncode = encodeURIComponent(gaIds);
  return gaIdsEncode;
};

export const getClientsIds = (context) => {
  const { clientIDs } = { ...context };
  const { ga: client_id, sessionId: session_id } = { ...clientIDs };
  const ga = {};
  if (client_id) {
    ga.client_id = client_id;
  }
  // se incluye session_id solo si existe client_id y tiene formato correcto
  if (session_id && client_id) {
    const gaRegex = /^\d+\.\d+$/;
    if (gaRegex.test(client_id)) {
      ga.session_id = session_id;
    }
  }
  const gaIds = JSON.stringify(ga);
  return gaIds;
};
